<template>
  <div id="contenedor-clientes-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <!-- ToolBar -->
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            v-on:nuevoCliente="registrarNuevoCliente"
            v-on:buscar="buscar"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :listado="getClientes">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Ventana para registrar nuevo cliente -->
    <v-dialog
      persistent
      v-model="mostrarVentanaRegistrarNuevoCliente"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <registrar-nuevo-cliente
        v-if="mostrarVentanaRegistrarNuevoCliente"
        v-on:cerrar="cerrarRegistrarNuevoCliente">
      </registrar-nuevo-cliente>
    </v-dialog>
    <!-- Ventana para editar cliente -->
    <v-dialog
      persistent
      v-if="esteCliente"
      v-model="mostrarVentanaEditarCliente"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <editar-cliente
      :clienteEditar="esteCliente"
        v-on:cerrar="cerrarEditarCliente">
      </editar-cliente>
    </v-dialog>
    <!-- Ventana para eliminar cliente -->
    <v-dialog
      persistent
      v-if="esteCliente"
      v-model="mostrarVentanaEliminarCliente"
      :width="!$vuetify.breakpoint.xs ? '500' : '90%'">
      <eliminar-cliente
      :clienteEliminar="esteCliente"
        v-on:cerrar="cerrarRemoverCliente">
      </eliminar-cliente>
    </v-dialog>
  </div>
</template>

<script>
import CLIENTES from '@/graphql/querys/administracion/catalogos/clientes/clientes.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevoCliente from '@/components/administracion/configuracion/catalogos/clientes/Nuevo.vue';
import EditarCliente from '@/components/administracion/configuracion/catalogos/clientes/Editar.vue';
import EliminarCliente from '@/components/administracion/configuracion/catalogos/clientes/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ClientesDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoCliente,
    EditarCliente,
    EliminarCliente,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoCliente: false,
      mostrarVentanaEditarCliente: false,
      mostrarVentanaEliminarCliente: false,
      esteCliente: null,
      buscarTexto: '',
    };
  },
  mounted() {
    eventBus.$on('editar-cliente', (cliente) => {
      this.esteCliente = cliente;
      this.mostrarVentanaEditarCliente = true;
    });
    eventBus.$on('eliminar-cliente', (cliente) => {
      this.esteCliente = cliente;
      this.mostrarVentanaEliminarCliente = true;
    });
  },
  methods: {
    buscar(buscarTexto) {
      this.buscarTexto = buscarTexto;
    },
    registrarNuevoCliente() {
      this.mostrarVentanaRegistrarNuevoCliente = true;
    },
    cerrarRegistrarNuevoCliente() {
      this.mostrarVentanaRegistrarNuevoCliente = false;
    },
    cerrarEditarCliente() {
      this.mostrarVentanaEditarCliente = false;
      this.esteCliente = null;
    },
    cerrarRemoverCliente() {
      this.mostrarVentanaEliminarCliente = false;
      this.esteCliente = null;
    },
  },
  apollo: {
    clientes: {
      query: CLIENTES,
    },
  },
  computed: {
    getClientes() {
      if (!this.clientes) return [];
      return this.clientes
        .filter((cliente) => {
          if (!this.buscarTexto) return cliente;
          const expt = new RegExp(this.buscarTexto, 'gi');

          const nombre = this.$normalizacionTexto(cliente.nombre);

          return (
            expt.test(nombre)
            || expt.test(cliente.nombre)
          );
        })
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
};
</script>

<style lang="scss">

</style>
